import { RichText } from '@hubspot/cms-components';
import React from 'react';
import { styled } from 'styled-components';
import { bp } from '../../../styles/breakPoints.tsx';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media ${bp.md} {
    flex-direction: row;
    gap: 32px;
  }
  h2 {
    font-size: 22px;
    line-height: 28px;
    font-weight: 700;
    margin: 0;

    @media ${bp.md} {
      font-size: 40px;
      line-height: normal;
    }
  }
`;
interface TitleTextHorizontalProps {
  fieldValues: {
    title: string;
    text: string;
  };
}

function TitleTextHorizontal(props: TitleTextHorizontalProps) {
  const { title } = props.fieldValues;

  return (
    <Wrapper>
      <h2 dangerouslySetInnerHTML={{ __html: title }}></h2>
      <RichText fieldPath='text' />
    </Wrapper>
  );
}

export default TitleTextHorizontal;
